import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAppRequest } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { stripHtml } from '@fui/fui-helpers';
import { NotifierService } from '@services/notifier.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FactorRowDesignerRelationsService } from '../../services/factor-row-designer-relations.service';
import { FactorRowHistoryService } from '../../services/factor-row-history.service';

@Component({
    selector: 'app-factor-history-dialog',
    templateUrl: './factor-history-dialog.component.html',
    styleUrls: ['./factor-history-dialog.component.scss'],
    providers: [FactorRowDesignerRelationsService],
})
export class FactorHistoryDialogComponent implements OnInit {
    protected readonly stripHtml = stripHtml;
    constructor(
        public dialogRef: MatDialogRef<FactorHistoryDialogComponent>,
        public formBuilder: FormBuilder,
        public appService: AppService,
        public spinner: NgxSpinnerService,
        public notifier: NotifierService,
        public dialog: MatDialog,
        public factorRowHistoryService: FactorRowHistoryService,
        public factorRowDesignerRelationsService: FactorRowDesignerRelationsService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            data: any;
            type: string;
        },
    ) {}

    /**
     * История изменений
     */
    historyData: any;

    /**
     * Флаг загрузки
     */
    isLoad = false;

    /**
     * Флаг загрузки
     */
    ngOnInit(): void {
        this.getHistory(this.data.type);
    }

    /**
     * Закрытие формы
     */
    close() {
        this.dialogRef.close({ save: false });
    }

    /**
     * Получить историю изменений
     */
    getHistory(type: string) {
        const recordType = this.data?.data?.recordType;
        let functionName = null;
        this.spinner.show();
        if (type === 'one') {
            functionName = this.factorRowHistoryService.getHistoryData(this.data.data);
        } else {
            functionName = this.factorRowHistoryService.getAllHistoryData(this.data.data);
        }
        if (recordType === 'link') {
            functionName = this.factorRowDesignerRelationsService.getHistoryData(this.data.data);
        }
        functionName
            .toPromise()
            .then((result: IAppRequest) => {
                this.spinner.hide();
                if (result && result.is_error === false) {
                    this.historyData = {
                        histories: result.data,
                        all_history: type === 'full',
                        column: {
                            is_date: true,
                            is_factor_name: true,
                            is_value: this.data.data.type !== 'relation',
                            is_current_value: true,
                            is_fio: true,
                            is_type: this.data.data.type === 'relation',
                        },
                        width: '50% - 415px',
                    };
                    this.isLoad = true;
                } else {
                    this.notifier.notify('error', result.message);
                }
            })
            .catch(() => {
                this.spinner.hide();
                this.notifier.notify('error', this.appService.language_dictionary.system_no_connection_with_system);
                this.close();
            });
    }
}
